import ColorThief from "color-thief-browser";
import { prominent } from "color.js";
import { toast } from "react-toastify";
import * as pdfjsLib from "pdfjs-dist";
import { MAX_COMPANY_NAME_LENGTH } from "./constant";
import { designStyle } from "./options";
import {
  Bathroom,
  Flooring,
  Furniture,
  Laminates,
  Lightning,
  Modular,
  Paints,
  Rugs,
  Stones,
  Tiles,
} from "../assets/materialBanners";
import materialIcons, { mIconimg539 } from "../assets/material-icons";
import { logos } from "../assets/logos";

export const getAxiosConfig = (params, isFormData, signal) => {
  const token = localStorage.getItem("usersdatatoken");
  return {
    //   method: "GET",
    headers: {
      "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      Authorization: token,
    },
    params: params || {},
    ...(signal ? { signal } : {}),
  };
};

// export const getTopColorsFromImages = async (imageUrls, topN = 8) => {
//   const allColors = [];
// console.log("Fetching colors from images:", imageUrls);
//   for (const src of imageUrls) {
//     try {
//       const img = new Image();
//       // img.crossOrigin = "use-credentials";
//       img.src = src;

//     const pr=   await new Promise((resolve, reject) => {
//         img.onload = resolve;
//         img.onerror = reject;
//       });
// console.log("PR", pr);
//       const colors = await ColorThief.getPalette(img, topN);
//       allColors.push(...colors);
//     } catch (err) {
//       console.error("Image failed:", src, err);
//     }
//   }

//   const colorCount = new Map();
//   for (const [r, g, b] of allColors) {
//     const hex = `#${r.toString(16).padStart(2, "0")}${g
//       .toString(16)
//       .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
//     colorCount.set(hex, (colorCount.get(hex) || 0) + 1);
//   }

//   return [...colorCount.entries()]
//     .sort((a, b) => b[1] - a[1])
//     .map(([hex]) => hex)
//     .slice(0, topN);

// };

// const blobToBase64 = (blob) =>
//   new Promise((resolve) => {
//     const reader = new FileReader();
//     reader.onloadend = () => resolve(reader.result);
//     reader.readAsDataURL(blob);
//   });

// const getTopColorsFromUrl = async (imageUrl, limit = 8) => {
//   try {
//     const response = await fetch(imageUrl);
//     const blob = await response.blob();
//     const base64 = await blobToBase64(blob);

//     const img = new Image();
//     img.src = base64;

//     await new Promise((res, rej) => {
//       img.onload = res;
//       img.onerror = rej;
//     });

//     const canvas = document.createElement("canvas");
//     canvas.width = img.width;
//     canvas.height = img.height;

//     const ctx = canvas.getContext("2d");
//     ctx.drawImage(img, 0, 0);

//     const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);

//     const colorMap = new Map();
//     for (let i = 0; i < data.length; i += 4) {
//       const [r, g, b, a] = [
//         data[i],
//         data[i + 1],
//         data[i + 2],
//         data[i + 3],
//       ];

//       if (a < 128) continue; // ignore transparent pixels

//       const hex = `#${[r, g, b]
//         .map((x) => x.toString(16).padStart(2, "0"))
//         .join("")}`;
//       colorMap.set(hex, (colorMap.get(hex) || 0) + 1);
//     }

//     return [...colorMap.entries()]
//       .sort((a, b) => b[1] - a[1])
//       .map(([color]) => color)
//       .slice(0, limit);
//   } catch (err) {
//     console.error("Color extraction failed for", imageUrl, err);
//     return [];
//   }
// };

// export const getTopColorsFromMultipleUrls = async (imageUrls, topN = 8) => {
//   const globalColorMap = new Map();
// console.log("Fetching colors from multiple URLs:", imageUrls);
//   for (const url of imageUrls) {
//     const colors = await getTopColorsFromUrl(url, topN);
//     for (const color of colors) {
//       globalColorMap.set(color, (globalColorMap.get(color) || 0) + 1);
//     }
//   }

//   return [...globalColorMap.entries()]
//     .sort((a, b) => b[1] - a[1])
//     .map(([color]) => color)
//     .slice(0, topN);
// };
// const blobToBase64 = (blob) =>
//   new Promise((resolve) => {
//     const reader = new FileReader();
//     reader.onloadend = () => resolve(reader.result);
//     reader.readAsDataURL(blob);
//   });

// // Helper function to convert hex to RGB
// const hexToRgb = (hex) => {
//   const r = parseInt(hex.slice(1, 3), 16);
//   const g = parseInt(hex.slice(3, 5), 16);
//   const b = parseInt(hex.slice(5, 7), 16);
//   return [r, g, b];
// };

// // Helper function to calculate Euclidean distance between two colors
// const colorDistance = (rgb1, rgb2) => {
//   return Math.sqrt(
//     (rgb1[0] - rgb2[0]) ** 2 +
//     (rgb1[1] - rgb2[1]) ** 2 +
//     (rgb1[2] - rgb2[2]) ** 2
//   );
// };

// // Helper function to check if two colors are too similar
// const isSimilarColor = (rgb1, rgb2, threshold = 30) => {
//   return colorDistance(rgb1, rgb2) < threshold;
// };

// const getTopColorsFromUrl = async (imageUrl, limit = 8) => {
//   try {
//     const response = await fetch(imageUrl);
//     const blob = await response.blob();
//     const base64 = await blobToBase64(blob);

//     const img = new Image();
//     img.src = base64;

//     await new Promise((res, rej) => {
//       img.onload = res;
//       img.onerror = rej;
//     });

//     const canvas = document.createElement("canvas");
//     canvas.width = img.width;
//     canvas.height = img.height;

//     const ctx = canvas.getContext("2d");
//     ctx.drawImage(img, 0, 0);

//     const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);

//     const colorMap = new Map();
//     for (let i = 0; i < data.length; i += 4) {
//       const [r, g, b, a] = [
//         data[i],
//         data[i + 1],
//         data[i + 2],
//         data[i + 3],
//       ];

//       if (a < 128) continue; // ignore transparent pixels

//       const hex = `#${[r, g, b]
//         .map((x) => x.toString(16).padStart(2, "0"))
//         .join("")}`;
//       colorMap.set(hex, (colorMap.get(hex) || 0) + 1);
//     }

//     return [...colorMap.entries()]
//       .sort((a, b) => b[1] - a[1])
//       .map(([color]) => color)
//       .slice(0, limit);
//   } catch (err) {
//     console.error("Color extraction failed for", imageUrl, err);
//     return [];
//   }
// };

// export const getTopColorsFromMultipleUrls = async (imageUrls, topN = 8) => {
//   const globalColorMap = new Map();
//   console.log("Fetching colors from multiple URLs:", imageUrls);

//   // Collect all colors from all images
//   for (const url of imageUrls) {
//     const colors = await getTopColorsFromUrl(url, topN * 20); // Get more colors to allow clustering
//     for (const color of colors) {
//       globalColorMap.set(color, (globalColorMap.get(color) || 0) + 1);
//     }
//   }

//   // Convert colors to RGB and sort by frequency
//   const sortedColors = [...globalColorMap.entries()]
//     .sort((a, b) => b[1] - a[1])
//     .map(([color, count]) => ({ hex: color, rgb: hexToRgb(color), count }));

//   // Cluster colors to avoid similar shades
//   const result = [];
//   for (const color of sortedColors) {
//     const isSimilar = result.some((selected) =>
//       isSimilarColor(selected.rgb, color.rgb, 30) // Adjust threshold as needed
//     );
//     if (!isSimilar) {
//       result.push(color);
//     }
//     if (result.length >= topN) break;
//   }

//   // Return the top N distinct colors as hex values
//   return result.map((color) => color.hex);
// };

// const rgbToHex = ([r, g, b]) => {
//   return `#${[r, g, b]
//     .map((x) => Math.round(x).toString(16).padStart(2, '0'))
//     .join('')}`;
// };

// // Helper function to calculate Euclidean distance between two RGB colors
// const colorDistance = (rgb1, rgb2) => {
//   return Math.sqrt(
//     (rgb1[0] - rgb2[0]) ** 2 +
//     (rgb1[1] - rgb2[1]) ** 2 +
//     (rgb1[2] - rgb2[2]) ** 2
//   );
// };

// // Helper function to check if two colors are too similar
// const isSimilarColor = (rgb1, rgb2, threshold = 30) => {
//   return colorDistance(rgb1, rgb2) < threshold;
// };

// export const getTopColorsFromMultipleUrls = async (imageUrls, topN = 8) => {
//   // console.log("Fetching colors from multiple URLs:", imageUrls);
//   const allColors = [];

//   // Collect colors from all images using color.js
//   for (const url of imageUrls) {
//     try {
//       const colors = await prominent(url, {
//         amount: topN * 2, // Get more colors to allow deduplication
//         format: 'array', // RGB arrays for distance calculations
//         group: 30, // Similar to previous threshold for grouping similar colors
//         sample: 20, // Sample every 20th pixel for performance
//       });
//       allColors.push(...colors.map(rgb => ({ rgb, hex: rgbToHex(rgb) })));
//     } catch (err) {
//       console.error("Color extraction failed for", url, err);
//     }
//   }

//   // Aggregate colors by frequency
//   const colorMap = new Map();
//   for (const color of allColors) {
//     colorMap.set(color.hex, (colorMap.get(color.hex) || 0) + 1);
//   }

//   // Sort by frequency and ensure distinct colors
//   const sortedColors = [...colorMap.entries()]
//     .sort((a, b) => b[1] - a[1])
//     .map(([hex, count]) => ({ hex, rgb: hexToRgb(hex), count }));

//   // Select distinct colors
//   const result = [];
//   const seenRgbs = [];
//   for (const color of sortedColors) {
//     if (
//       !seenRgbs.some((seen) => isSimilarColor(seen, color.rgb, 30))
//     ) {
//       result.push(color.hex);
//       seenRgbs.push(color.rgb);
//     }
//     if (result.length >= topN) break;
//   }

//   // If fewer than topN colors, add more from sorted list
//   if (result.length < topN) {
//     const remainingColors = sortedColors.filter(
//       (color) => !result.includes(color.hex)
//     );
//     for (const color of remainingColors) {
//       result.push(color.hex);
//       if (result.length >= topN) break;
//     }
//   }

//   return result.slice(0, topN);
// };

// Helper function to convert hex to RGB (for distance calculations)
// const hexToRgb = (hex) => {
//   const r = parseInt(hex.slice(1, 3), 16);
//   const g = parseInt(hex.slice(3, 5), 16);
//   const b = parseInt(hex.slice(5, 7), 16);
//   return [r, g, b];
// };
export const getImageUrls = (imgArr, isMinio, isRemoveMinioSize = false) => {
  if (
    !imgArr ||
    !Array.isArray(imgArr) ||
    imgArr.length === 0 ||
    !imgArr[0] ||
    imgArr[0]?.length === 0
  ) {
    return [];
  }
  // console.log("-------IMG ARR-----------", imgArr)
  return imgArr.map((img) => {
    if (typeof img === "string") {
      if (img.includes("/api/minio/static")) {
        return img;
      } else if (img.includes("/api/minio")) {
        return isRemoveMinioSize && img ? img?.split("?")[0] : img;
      }
      return isMinio
        ? `${process.env.REACT_APP_BACK_URL}/api/minio/${img}${
            isRemoveMinioSize ? "" : getMinioSize()
          }`
        : img;
    } else if (img instanceof File || img instanceof Blob) {
      return URL.createObjectURL(img);
    }
  });
};
export const getMinioImage = (image, isRemoveMinioSize = false) => {
  return getImageUrls([image], true, isRemoveMinioSize)?.[0];
  // return `${process.env.REACT_APP_BACK_URL}/api/minio/${image}`;
};

export const checkImageOrientation = (file) => {
  return new Promise((resolve, reject) => {
    if (!(file instanceof File)) {
      return reject(new Error("Invalid file type"));
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = function () {
      const isPortrait = img.height > img.width;
      URL.revokeObjectURL(objectUrl); // Clean up
      resolve(isPortrait);
    };

    img.onerror = function () {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Could not load image"));
    };

    img.src = objectUrl;
  });
};

export const validateSiteForm = (data, isHideToast) => {
  if (data?.companyName?.trim() === "") {
    if (!isHideToast) toast.error("Company name is required");
    return false;
  }
  if (data?.companyName?.length > MAX_COMPANY_NAME_LENGTH) {
    if (!isHideToast)
      toast.error(
        `Company logo should be less than ${MAX_COMPANY_NAME_LENGTH} characters`,
      );
    return false;
  }
  if (data?.companyLogo?.length === 0) {
    if (!isHideToast) toast.error("Company logo is required");
    return false;
  }

  if (data?.address?.trim() === "") {
    !isHideToast && toast.error("Address is required");
    return false;
  }
  // if(data?.siteImage?.length === 0) {
  //  !isHideToast &&  toast.error("Site image is required");
  //   return false;
  // }
  let isErr = true;
  console.log(data?.buildingData?.[0]?.image?.length);
  for (let i = 0; i < data?.buildingData?.length; i++) {
    const building = data.buildingData[i];
    console.log({ building });
    // if(building?.floorMap?.length === 0) {
    //   !isHideToast && toast.error(`Floor map is required for building ${i+1}`);
    //   isErr = false;
    //   break;
    // }
    if (building?.image?.length > 4 || building?.image?.length < 2) {
      // console.log("asdf")
      !isHideToast &&
        toast.error(`2-4 Images are allowed for building ${i + 1}`);
      isErr = false;
      break;
    }
    if (building?.title?.trim() === "") {
      // console.log("asdf1")

      !isHideToast && toast.error(`Title is required for building ${i + 1}`);
      isErr = false;
      break;
    }
    // console.log(building?.description?.length, i+1);
    if (building?.description?.length > 300) {
      !isHideToast &&
        toast.error(
          `Description should be less than 300 chars for building ${i + 1}`,
        );
      isErr = false;
      break;
    }
    if (building?.description?.length < 20) {
      !isHideToast &&
        toast.error(
          `Description should be at least 20 chars for building ${i + 1}`,
        );
      isErr = false;
      break;
    }
  }
  return isErr;
};

export const getBase64ImageFromUrl = (url) =>
  new Promise((resolve, reject) => {
    // console.log(url, "BASE 64")
    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = function () {
      try {
        // Ensure image is fully loaded
        if (img.complete && img.naturalWidth > 0 && img.naturalHeight > 0) {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          const ctx = canvas.getContext("2d");

          // Clear canvas with white background
          // ctx.fillStyle = "#FFFFFF";
          // ctx.fillRect(0, 0, canvas.width, canvas.height);

          // Draw image
          ctx.drawImage(img, 0, 0);

          // Convert to base64 with error handling
          try {
            const dataURL = canvas.toDataURL("image/png");
            if (dataURL && dataURL.startsWith("data:image/")) {
              // console.log(
              //   `Successfully converted image: ${url.substring(0, 50)}...`
              // );
              resolve(dataURL);
            } else {
              throw new Error("Invalid data URL generated");
            }
          } catch (canvasError) {
            console.error("Canvas conversion failed:", canvasError);
            resolve(url); // Fallback to original URL
          }
        } else {
          console.error("Image not properly loaded:", url);
          resolve(url); // Fallback to original URL
        }
      } catch (error) {
        console.error("Error in image processing:", error);
        resolve(url); // Fallback to original URL
      }
    };

    img.onerror = function (e) {
      console.error("Failed to load image:", url, e);
      resolve(url); // Fallback to original URL
    };

    // Add timeout to prevent hanging
    setTimeout(() => {
      if (!img.complete) {
        console.warn("Image loading timeout:", url);
        resolve(url); // Fallback to original URL
      }
    }, 10000); // 10 second timeout

    img.src = url;
  });

export const getFlipbookHeight = (width) => {
  if (width > 640) {
    return width / 1.77;
  }
  // else{
  else if (width <= 640 && width > 480) {
    return width / 1.4;
  } else {
    return 520 / 1.77;
    return width / 1.4;
  }
  // }
};

// Convert RGB to HEX
const rgbToHex = ([r, g, b]) =>
  "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");

// Convert HEX back to RGB
const hexToRgb = (hex) => {
  const bigint = parseInt(hex.slice(1), 16);
  return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
};

// Euclidean distance between two RGBs
const colorDistance = (rgb1, rgb2) =>
  Math.sqrt(
    (rgb1[0] - rgb2[0]) ** 2 +
      (rgb1[1] - rgb2[1]) ** 2 +
      (rgb1[2] - rgb2[2]) ** 2,
  );

// Check if two colors are too similar
const isSimilarColor = (rgb1, rgb2, threshold = 30) =>
  colorDistance(rgb1, rgb2) < threshold;

// Calculate saturation (0–100)
const getSaturation = ([r, g, b]) => {
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  return max === 0 ? 0 : ((max - min) / max) * 100;
};

// Check if color is near white or black
const isNearNeutral = ([r, g, b], tolerance = 30) => {
  const avg = (r + g + b) / 3;
  return avg < tolerance || avg > 255 - tolerance;
};

export const getTopColorsFromMultipleUrls = async (imageUrls, topN = 8) => {
  // console.log({ COLORS: imageUrls });
  const allColors = [];

  // Extract colors from each image
  for (const url of imageUrls) {
    try {
      const colors = await prominent(url, {
        amount: topN * 4, // grab a bigger pool initially
        format: "array",
        group: 20,
        sample: 20,
      });

      allColors.push(
        ...colors.map((rgb) => ({
          rgb,
          hex: rgbToHex(rgb),
          sat: getSaturation(rgb),
        })),
      );
    } catch (err) {
      console.error("Color extraction failed for", url, err);
    }
  }

  // Filter out blacks/whites
  let filteredColors = allColors.filter((c) => !isNearNeutral(c.rgb));

  // Sort by (saturation * frequency)
  const colorMap = new Map();
  for (const color of filteredColors) {
    const key = color.hex;
    if (!colorMap.has(key)) {
      colorMap.set(key, { ...color, count: 0 });
    }
    colorMap.get(key).count += 1;
  }

  const sortedColors = [...colorMap.values()].sort(
    (a, b) => b.sat * b.count - a.sat * a.count,
  );

  // Ensure distinct colors
  const result = [];
  const seenRgbs = [];
  for (const color of sortedColors) {
    if (!seenRgbs.some((seen) => isSimilarColor(seen, color.rgb, 35))) {
      result.push(color.hex);
      seenRgbs.push(color.rgb);
    }
    if (result.length >= topN) break;
  }

  // Fallback: if too few results, fill with remaining
  if (result.length < topN) {
    for (const color of sortedColors) {
      if (!result.includes(color.hex)) {
        result.push(color.hex);
        if (result.length >= topN) break;
      }
    }
  }

  return result.slice(0, topN);
};

export const getMoodboardArray = (areas) => {
  const ans = [];

  let designArr = areas?.[0]?.designStyle;
  if (areas?.[0]?.designStyle) {
    ans.push({
      isDesign: true,
      designStyle: areas?.[0]?.designStyle,
    });
  }

  (areas || []).forEach((area) => {
    let isDesignMatched = area?.designStyle == designArr;
    if (!isDesignMatched && designArr) {
      ans.push({
        isDesign: true,
        designStyle: area?.designStyle,
      });
      designArr = area?.designStyle;
    }
    // else{
    ans.push({
      isDesign: false,
      area: area,
    });
    // }
  });

  console.log("SORTED", ans);
  return ans;
};

export function getMinioSize(customSizeArr) {
  const width = window.innerWidth;
  if (width < 640) {
    return `?size=${customSizeArr?.[0] ? customSizeArr?.[0] : "small"}`;
  } else if (width >= 640 && width < 1024) {
    return `?size=${customSizeArr?.[1] ? customSizeArr?.[1] : "medium"}`;
  } else {
    return `?size=${customSizeArr?.[2] ? customSizeArr?.[2] : "large"}`;
  }
}

export const getOptimizedAssets = (assets) => {
  const width = window.innerWidth;
  if (width <= 480) {
    return assets[0];
  } else if (width > 480 && width <= 768) {
    return assets[1];
  } else {
    if (assets.length == 3) {
      return assets[2];
    } else {
      // console.log("EXTRA LARGE")
      if (width <= 1200) {
        return assets[2];
      } else return assets[3];
    }
  }
};

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

/**
 * Converts the first page of a PDF file to an image blob
 * @param {File} pdfFile - The PDF file to convert
 * @param {number} scale - Scale factor for the output image (default: 1.5)
 * @param {string} format - Output image format ('image/jpeg' or 'image/png')
 * @returns {Promise<{blob: Blob, file: File}>} - Returns both blob and file objects
 */
export const convertPdfToImage = async (
  pdfFile,
  scale = 1.5,
  format = "image/jpeg",
) => {
  try {
    // Read the PDF file as array buffer
    const arrayBuffer = await pdfFile.arrayBuffer();

    // Load the PDF document
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

    // Get the first page
    const page = await pdf.getPage(1);

    // Set up the canvas
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    // Render the page
    const renderContext = {
      canvasContext: context,
      viewport: viewport,
    };

    await page.render(renderContext).promise;

    // Convert canvas to blob
    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (blob) {
            // Create a File object from the blob
            const fileName = pdfFile.name.replace(".pdf", ".jpg");
            const imageFile = new File([blob], fileName, {
              type: format,
              lastModified: Date.now(),
            });

            // resolve({
            //   blob: blob,
            //   file: imageFile
            // });
            resolve(imageFile);
          } else {
            reject(new Error("Failed to convert canvas to blob"));
          }
        },
        format,
        0.8,
      ); // 0.8 is the quality for JPEG
    });
  } catch (error) {
    throw new Error(`PDF conversion failed: ${error.message}`);
  }
};

export const getDesignBgImage = (style, designBg) => {
  const ds = designStyle.find((v) => v.name === style);
  if (!ds) return null;
  const index =
    designBg && designBg.includes("background")
      ? parseInt(designBg?.split(" ")[1]) - 1
      : 0;

  return ds?.bgArray?.[index] || ds?.bgArray?.[0] || null;
};

export const getGoogleFormData = (data = [], width) => {
  const height = width / 1.9611; // (1.9611 = containerWidth/heightof table parent)
  const rowH = 16 + 16; // 16 padding, 16 lh
  const perLineChars = width / (width < 640 ? 6.2 : 5.765); //765

  let ans = [];

  // intro page calucltion
  let contentHeadings = data.map((v) => v.heading);
  let PerPageRows = Math.ceil(
    width / 1.8426 / (width <= 475 ? 26.5 : width < 768 ? 36.5 : 32.5),
  );
  let totalIndexPages = Math.ceil(contentHeadings.length / PerPageRows);
  for (let i = 0; i < totalIndexPages; i++) {
    const start = i * PerPageRows;
    const end = start + PerPageRows;
    ans.push({
      isIntro: true,
      heading: "Content",
      fields: contentHeadings.slice(start, end), // ✅ use slice instead of splice
    });
  }

  console.log("BACK", PerPageRows, width);

  // main page calculations
  data.forEach((val) => {
    let maxPerRow = Math.floor(height / rowH);

    let obj = {
      heading: val.heading,
    };
    let i = 0;
    ans.push({ ...obj, isHeadingPage: true });

    // alignning tableData
    while (i < val.tableData?.length) {
      let obj2 = { ...obj };
      let insideMaxTow = 0;
      let incRowsCount = 0;
      let flag = true;
      [...val.tableData]
        ?.splice(i, maxPerRow)
        .map((v) => v?.label)
        .forEach((v) => {
          if (flag) {
            const lines = Math.ceil(v.length / perLineChars);
            let temp = insideMaxTow;
            temp += 0.5 + lines * 0.5;
            if (temp > maxPerRow) {
              flag = false;
            } else {
              incRowsCount++;
              insideMaxTow = temp;
            }
            // insideMaxTow+=0.5 + (lines*0.5)
          }
        });
      // console.log({heading: val?.heading, maxPerRow,incRowsCount, insideMaxTow,perLineChars})
      // incRowsCount
      // console.log("ASDF", {
      //           length: val?.tableData?.length,
      //           maxPerRow,
      //           insideMaxTow,
      //           incRowsCount,
      //           // rows: incRowsCount / (2 / 1),
      //           heading: obj?.heading,
      //           dataLength: [...val.tableData]?.splice(i, maxPerRow).length,
      //           perLineChars
      //           // mod,
      //         });

      obj2["tableData"] = [...val.tableData]?.splice(i, incRowsCount);
      let incI = i + incRowsCount;

      if (incI >= val?.tableData?.length && val?.remarks) {
        const mod =
          // val?.tableData?.length % (incRowsCount + (maxPerRow - incRowsCount)); //last page rows
          val?.tableData?.length % maxPerRow; //last page rows

        // console.log("ASDF", {
        //   length: val?.tableData?.length,
        //   incRowsCount,
        //   insideMaxTow,
        //   maxPerRow,
        //   dataLength: [...val.tableData]?.splice(i, maxPerRow).length,
        //   rows: incRowsCount / (2 / 1),
        //   heading: obj?.heading,
        //   // mod,
        // });
        if (mod != 0 && mod <= maxPerRow / (width < 640 ? 2 / 1 : 3 / 2)) {
          // maxRow/ (totalParts/selectedParts)
          //add remark means space left
          obj2["remarks"] = val?.remarks;
          ans.push(obj2);
          i += incRowsCount;
        } else {
          ans.push(obj2);
          ans.push({ ...obj, remarks: val?.remarks });
          i += incRowsCount;
        }
      } else {
        ans.push(obj2);
        i += incRowsCount;
      }
    }
    if (val?.images?.length > 0) {
      ans.push({
        ...obj,
        isImage: true,
        images: val?.images,
        isVideo: obj.heading.toLowerCase() == "site video",
      });
    }
  });

  return ans;
};

export const convertDataFormat = (data1) => {
  // Static mapping of headings to their fields
  console.log("DATA1", data1);
  const fieldMapping = {
    "Basic Details": [
      // { label: "Timestamp", key: "Timestamp" },
      // { label: "Email address", key: "Email address" },
      // { label: "Score", key: "Score" },
      // { label: "Name", key: "Name" },
      { label: "Project Name", key: "Project Name" },
      { label: "Site Location (Address)", key: "Site Location (Address)" },
      { label: "Site Location Drop (Link)", key: "Site Location Drop (Link)" },
      { label: "City", key: "City" },
      { label: "No. of Floors", key: "No. of Floors" },
      { label: "Area per floor", key: "Area per floor" },
      { label: "Face height ", key: "Face height " },
      { label: "Autocad availability", key: "Autocad availability" },
      { label: "Total Area - as built", key: "Total Area - as built" },
      {
        label:
          "Column grid c/c, beam and capital bottom levels measurements (height)",
        key: "Column grid c/c, beam and capital bottom levels measurements (height)",
      },
      { label: "Floor to ceiling Height", key: "Floor to ceiling Height" },
      { label: "Staircase turning radius", key: "Staircase turning radius" },
      {
        label: "Any floor level difference ",
        key: "Any floor level difference ",
      },
      { label: "Wall Undulation", key: "Wall Undulation" },
      {
        label: "Existing Door & Windows (Dimensions & condition)",
        key: "Existing Door & Windows (Dimensions & condition)",
      },
      { label: "Fire Fighting -  Lines", key: "Fire Fighting -  Lines" },
      { label: "Sprinklers", key: "Sprinklers" },
      {
        label: "Existing Location of Fire Header Pipe Line",
        key: "Existing Location of Fire Header Pipe Line",
      },
      { label: "Fire Alarm", key: "Fire Alarm" },
    ],
    SURROUNDINGS: [
      {
        label: "Connectivity to nearby Highway",
        key: "SURROUNDINGS [Connectivity to nearby Highway]",
      },
      {
        label:
          "Transport arrangements or vehicle movement restrictions within the premises",
        key: "SURROUNDINGS [Transport arrangements or vehicle movement restrictions within the premises]",
      },
      {
        label: "Adequate site movement road widths",
        key: "SURROUNDINGS [Adequate site movement road widths]",
      },
      {
        label: "Parking restrictions",
        key: "SURROUNDINGS [Parking restrictions]",
      },
      {
        label: "Adjacent land uses – e.g. schools, railway lines or busy roads",
        key: "SURROUNDINGS [Adjacent land uses – e.g. schools, railway lines or busy roads]",
      },
      { label: "Nearest Metro", key: "SURROUNDINGS [Nearest Metro]" },
    ],
    "NECESSARY RULES & REGULATIONS": [
      {
        label: "Site hoarding requirements",
        key: "NECESSARY RULES & REGULATIONS [Site hoarding requirements]",
      },
      {
        label: "Work timing restrictions (Example - National Holidays)",
        key: "NECESSARY RULES & REGULATIONS [Work timing restrictions (Example - National Holidays)]",
      },
      {
        label: "Security Personnel/system",
        key: "NECESSARY RULES & REGULATIONS [Security Personnel/system]",
      },
      {
        label: "Builder permissions (for any planned drilling/core cutting)",
        key: "NECESSARY RULES & REGULATIONS [Builder permissions (for any planned drilling/core cutting)]",
      },
      {
        label: "Service Lift",
        key: "NECESSARY RULES & REGULATIONS [Service Lift]",
      },
      {
        label: "Waste Dumping",
        key: "NECESSARY RULES & REGULATIONS [Waste Dumping]",
      },
      {
        label: "Restrictions on deliveries or waste collections",
        key: "NECESSARY RULES & REGULATIONS [Restrictions on deliveries or waste collections]",
      },
      {
        label: "24 Hrs Work Front availability",
        key: "NECESSARY RULES & REGULATIONS [24 Hrs Work Front availability]",
      },
      {
        label: "Local Police/ Union Bodies liasoning",
        key: "NECESSARY RULES & REGULATIONS [Local Police/ Union Bodies liasoning]",
      },
      {
        label: "Uninterrupted support from Govt. Bodies (water/electrical)",
        key: "NECESSARY RULES & REGULATIONS [Uninterrupted support from Govt. Bodies (water/electrical)]",
      },
      { label: "Fire NOC", key: "NECESSARY RULES & REGULATIONS [Fire NOC]" },
      { label: "Lift NOC", key: "NECESSARY RULES & REGULATIONS [Lift NOC]" },
      {
        label: "Exhaust System",
        key: "NECESSARY RULES & REGULATIONS [Exhaust System]",
      },
      {
        label: "Temporary Shut Down Approvals (lunch hours/late hours)",
        key: "NECESSARY RULES & REGULATIONS [Temporary Shut Down Approvals (lunch hours/late hours)]",
      },
    ],
    "HEALTH & HYGIENE": [
      {
        label: "Accomodation for labour on site",
        key: "HEALTH & HYGIENE [Accomodation for labour on site]",
      },
      {
        label: "Food for labour on site",
        key: "HEALTH & HYGIENE [Food for labour on site]",
      },
      { label: "Temporary Toilet", key: "HEALTH & HYGIENE [Temporary Toilet]" },
      {
        label: "Temporary Office Provision & Charges",
        key: "HEALTH & HYGIENE [Temporary Office Provision & Charges]",
      },
      {
        label: "Temporary material storage",
        key: "HEALTH & HYGIENE [Temporary material storage]",
      },
      {
        label: "Temporary material dumping",
        key: "HEALTH & HYGIENE [Temporary material dumping]",
      },
    ],
    FACADE: [
      {
        label: "Scaffolding availabilitity",
        key: "FACADE [Scaffolding availabilitity]",
      },
      {
        label: "Any special consideration and work",
        key: "FACADE [Any special consideration and work]",
      },
      {
        label: "No of sides covered by facade",
        key: "FACADE [No of sides covered by facade]",
      },
    ],
    "ELECTRICAL & HVAC": [
      {
        label: "Earthing provisions availablity",
        key: "ELECTRICAL & HVAC [Earthing provisions availablity]",
      },
      {
        label: "Tap off Point for HVAC",
        key: "ELECTRICAL & HVAC [Tap off Point for HVAC]",
      },
      { label: "Transformers", key: "ELECTRICAL & HVAC [Transformers]" },
      {
        label: "TFA ( Treated fresh air unit) - For Chiller Mechanism-",
        key: "ELECTRICAL & HVAC [TFA ( Treated fresh air unit) - For Chiller Mechanism-]",
      },
      {
        label: "Electrical Main Power Distribution Panel",
        key: "ELECTRICAL & HVAC [Electrical Main Power Distribution Panel]",
      },
      {
        label: "Existing Main Power Line ( Main cable)",
        key: "ELECTRICAL & HVAC [Existing Main Power Line ( Main cable)]",
      },
      {
        label: "Location of Existing FA & PA Panel",
        key: "ELECTRICAL & HVAC [Location of Existing FA & PA Panel]",
      },
      {
        label: "Location of Main FA Panel detector by builder",
        key: "ELECTRICAL & HVAC [Location of Main FA Panel detector by builder]",
      },
      {
        label: "Genset (DG)/ Power back up availability",
        key: "ELECTRICAL & HVAC [Genset (DG)/ Power back up availability]",
      },
      {
        label: "Usability of existing electrical / ups / ac panels",
        key: "ELECTRICAL & HVAC [Usability of existing electrical / ups / ac panels]",
      },
      {
        label: "AHU room dimensions (Available, if any)",
        key: "ELECTRICAL & HVAC [AHU room dimensions (Available, if any)]",
      },
      {
        label: "Locations available for ODUs",
        key: "ELECTRICAL & HVAC [Locations available for ODUs]",
      },
      {
        label: "Server-Hub room Locations",
        key: "ELECTRICAL & HVAC [Server-Hub room Locations]",
      },
    ],
    "ELECTRICAL WORKS": [
      {
        label: "Power Supply for Campus:-  Incoming Power Supply- 11KV",
        key: "ELECTRICAL WORKS [Power Supply for Campus:-  Incoming Power Supply- 11KV]",
      },
      {
        label:
          "Power Supply for Campus:-  Redundant Incoming feeder in Substation",
        key: "ELECTRICAL WORKS [Power Supply for Campus:-  Redundant Incoming feeder in Substation]",
      },
      {
        label:
          "Power Supply for Campus:-  Distribution of Power Supply to Buildings",
        key: "ELECTRICAL WORKS [Power Supply for Campus:-  Distribution of Power Supply to Buildings]",
      },
      {
        label:
          "Power Supply for Campus:-  Development Charges for power supply",
        key: "ELECTRICAL WORKS [Power Supply for Campus:-  Development Charges for power supply]",
      },
      {
        label: "Power Supply for Campus:-  O&M of Sub Station(SS)",
        key: "ELECTRICAL WORKS [Power Supply for Campus:-  O&M of Sub Station(SS)]",
      },
      {
        label:
          "Power Supply for Campus:-  Statutory Approval & Commissioning of 11KV SS",
        key: "ELECTRICAL WORKS [Power Supply for Campus:-  Statutory Approval & Commissioning of 11KV SS]",
      },
      {
        label: "Transformers:-  100% Distribution Transformers",
        key: "ELECTRICAL WORKS [Transformers:-  100% Distribution Transformers]",
      },
      {
        label: "HT Breaker Panels- 11 KV:-  HT Panels",
        key: "ELECTRICAL WORKS [HT Breaker Panels- 11 KV:-  HT Panels]",
      },
      {
        label:
          "Metering Station:-  Single Tenant Building- Common Meter to be provided by the Builder for the entire Tower-6 to measure power consumption for all applications including HVAC.Multi tenant Building Tower 3 & Tower 5 : Energy Meters at Floor Level to be provided to measure power consumption for all applications including HVAC",
        key: "ELECTRICAL WORKS [Metering Station:-  Single Tenant Building- Common Meter to be provided by the Builder for the entire Tower-6 to measure power consumption for all applications including HVAC.Multi tenant Building Tower 3 & Tower 5 : Energy Meters at Floor Level to be provided to measure power consumption for all applications including HVAC]",
      },
      {
        label:
          "UPS power supply:-  For Emergency Lighting & IBMS Systems in Common Area",
        key: "ELECTRICAL WORKS [UPS power supply:-  For Emergency Lighting & IBMS Systems in Common Area]",
      },
      {
        label: "Earthing:-  Common Area Earthing by developer",
        key: "ELECTRICAL WORKS [Earthing:-  Common Area Earthing by developer]",
      },
      {
        label:
          "Power Distribution Requirements:-  Main LT Panel with Bus coupler to segregate total EB & DG power",
        key: "ELECTRICAL WORKS [Power Distribution Requirements:-  Main LT Panel with Bus coupler to segregate total EB & DG power]",
      },
      {
        label:
          "Power Distribution Requirements:-  Dual feeders for critical loads like UPS in Main LT Panel .",
        key: "ELECTRICAL WORKS [Power Distribution Requirements:-  Dual feeders for critical loads like UPS in Main LT Panel .]",
      },
      {
        label:
          "Power Distribution Requirements:-  Digital Energy Meters compatible for BMS integration at all outgoing feeders in HT Panels, Elevator Panel, Fire Fighting & Plumbing services panel, Basement Ventilation,External Lighting,WTP&STP.",
        key: "ELECTRICAL WORKS [Power Distribution Requirements:-  Digital Energy Meters compatible for BMS integration at all outgoing feeders in HT Panels, Elevator Panel, Fire Fighting & Plumbing services panel, Basement Ventilation,External Lighting,WTP&STP.]",
      },
      {
        label:
          "Power Distribution Requirements:-  Energy Meters compatible for BMS integration at all outgoing feeders in Main LT Panel , Floor Panels and Chiller MCC Panel,",
        key: "ELECTRICAL WORKS [Power Distribution Requirements:-  Energy Meters compatible for BMS integration at all outgoing feeders in Main LT Panel , Floor Panels and Chiller MCC Panel,]",
      },
      {
        label:
          "Power Distribution Requirements:-  Vertical Power Distribution- Rising Mains - and Tap off with floor Panels.",
        key: "ELECTRICAL WORKS [Power Distribution Requirements:-  Vertical Power Distribution- Rising Mains - and Tap off with floor Panels.]",
      },
      {
        label:
          "Power Distribution Requirements:-  Rising Mains for Raw Power (AHUs,printers),and Lighting",
        key: "ELECTRICAL WORKS [Power Distribution Requirements:-  Rising Mains for Raw Power (AHUs,printers),and Lighting]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:-  HT Power Generation & Distribution",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:-  HT Power Generation & Distribution]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:- Power Transformers- 2x 100%",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:- Power Transformers- 2x 100%]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:-  Main LT Panels",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:-  Main LT Panels]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:-  UPS for Common Area Emergency Lighting & IBMS",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:-  UPS for Common Area Emergency Lighting & IBMS]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:-  Earthing for Common Area & Building",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:-  Earthing for Common Area & Building]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:-  All Cabling & Earthing system for 11kv upto DSS HT Breaker",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:-  All Cabling & Earthing system for 11kv upto DSS HT Breaker]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:-  Lightning Protection",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:-  Lightning Protection]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:-  External & Aviation Lighting",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:-  External & Aviation Lighting]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:-  Elevator System with Power Distribution",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:-  Elevator System with Power Distribution]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:-  Power Distribution System for Plumbing & Fire Fighting systems",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:-  Power Distribution System for Plumbing & Fire Fighting systems]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:-  Common Area Lighting- Car Parking,Common Area Toilets,Staircase,Lift Lobby,Terrace , street, etc.,",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:-  Common Area Lighting- Car Parking,Common Area Toilets,Staircase,Lift Lobby,Terrace , street, etc.,]",
      },
      {
        label:
          "Battery Limits for Power Generation & Distribution System:-  Earthing Grid - for common services in the Building",
        key: "ELECTRICAL WORKS [Battery Limits for Power Generation & Distribution System:-  Earthing Grid - for common services in the Building]",
      },
    ],
    Civil: [
      {
        label:
          "All Civil Works related to MEP Equipments like Foundations & Trenches",
        key: "Civil [All Civil Works related to MEP Equipments like Foundations & Trenches]",
      },
      {
        label:
          "Civil Works - screeding for floors, Utility Building & Service Tunnels for CHW piping , PHE Piping , Service provider cables, & Electrical",
        key: "Civil [Civil Works - screeding for floors, Utility Building & Service Tunnels for CHW piping , PHE Piping , Service provider cables, & Electrical]",
      },
      {
        label:
          "Toilet provisions as per NBC norms & test fit- out - Masonry works & Doors",
        key: "Civil [Toilet provisions as per NBC norms & test fit- out - Masonry works & Doors]",
      },
      {
        label: 'Finishing works for Occupied Areas - upto Floor Screeding"',
        key: 'Civil [Finishing works for Occupied Areas - upto Floor Screeding"]',
      },
      {
        label: 'MEP Services Rooms with Epoxy painted floors "',
        key: 'Civil [MEP Services Rooms with Epoxy painted floors "]',
      },
    ],
    HVAC: [
      {
        label:
          "Chilled water Generation & Distribution system including power termination",
        key: "HVAC [Chilled water Generation & Distribution system including power termination]",
      },
      {
        label: "Air Handling Units and Starter Panels-",
        key: "HVAC [Air Handling Units and Starter Panels-]",
      },
      {
        label:
          "Complete insulated CHW piping , valves & fittings including 2 way control valves",
        key: "HVAC [Complete insulated CHW piping , valves & fittings including 2 way control valves]",
      },
      {
        label: "Toilet Exhaust Fans with starter panels",
        key: "HVAC [Toilet Exhaust Fans with starter panels]",
      },
      { label: "VFDs for AHUs", key: "HVAC [VFDs for AHUs]" },
      {
        label: "Basement ventilation Fans with starter panels",
        key: "HVAC [Basement ventilation Fans with starter panels]",
      },
      {
        label: "Staircase Pressurisation Fans and starter panels",
        key: "HVAC [Staircase Pressurisation Fans and starter panels]",
      },
      {
        label: "Heat Recovery units for Fresh air treatment",
        key: "HVAC [Heat Recovery units for Fresh air treatment]",
      },
      {
        label: "Power cabling & Earthing LT Panel and individual AHU starters",
        key: "HVAC [Power cabling & Earthing LT Panel and individual AHU starters]",
      },
      {
        label: "Building Management System",
        key: "HVAC [Building Management System]",
      },
      {
        label:
          "Façade System, All windows ( Double Glazing ) & Doors are to be made air tight to avoid conditioned air leakages. Openable panels as per CFO norms are to be provided.",
        key: "HVAC [Façade System, All windows ( Double Glazing ) & Doors are to be made air tight to avoid conditioned air leakages. Openable panels as per CFO norms are to be provided.]",
      },
      {
        label:
          "All shafts for MEP Services with access doors and Fire Separation at floor levels",
        key: "HVAC [All shafts for MEP Services with access doors and Fire Separation at floor levels]",
      },
      {
        label: "Underdeck insulation to be provided for Top Slab with PUF/EPS.",
        key: "HVAC [Underdeck insulation to be provided for Top Slab with PUF/EPS.]",
      },
      {
        label:
          "Epoxy Painting for the Floors in AHU, Electrical and UPS Rooms .",
        key: "HVAC [Epoxy Painting for the Floors in AHU, Electrical and UPS Rooms .]",
      },
      {
        label:
          "Fire Seal required separating the floors at the junction of façade and slabs",
        key: "HVAC [Fire Seal required separating the floors at the junction of façade and slabs]",
      },
      {
        label:
          "Water supply connection with taps to be provided in each AHU room for filter cleaning.",
        key: "HVAC [Water supply connection with taps to be provided in each AHU room for filter cleaning.]",
      },
    ],
    "FIRE PROTECTION SYSTEM": [
      {
        label:
          "Fire License to be obtained by the Developer for the entire facility.",
        key: "FIRE PROTECTION SYSTEM [Fire License to be obtained by the Developer for the entire facility.]",
      },
      {
        label:
          "Sprinkler Piping vertical risers and tap off with Butterfly valves and flow sensors at each floor level",
        key: "FIRE PROTECTION SYSTEM [Sprinkler Piping vertical risers and tap off with Butterfly valves and flow sensors at each floor level]",
      },
      {
        label:
          "Distribution piping sized for 2 layers of sprinklers inside the floor with Upright Sprinklers and tapping provision for pendant sprinklers in occupied areas",
        key: "FIRE PROTECTION SYSTEM [Distribution piping sized for 2 layers of sprinklers inside the floor with Upright Sprinklers and tapping provision for pendant sprinklers in occupied areas]",
      },
      {
        label: "Fire Extinguishers in all common areas-",
        key: "FIRE PROTECTION SYSTEM [Fire Extinguishers in all common areas-]",
      },
      {
        label:
          "High Velocity Deluge System/ Fire fighting system for Transformer Yard to be provided by Developer.",
        key: "FIRE PROTECTION SYSTEM [High Velocity Deluge System/ Fire fighting system for Transformer Yard to be provided by Developer.]",
      },
      {
        label: "External & Internal Fire Hydrant Systems",
        key: "FIRE PROTECTION SYSTEM [External & Internal Fire Hydrant Systems]",
      },
    ],
    PHE: [
      {
        label:
          "PLUMBING SYSTEM-  Complete water supply, soil,waste & vent piping risers, sumps, underground piping upto the STP will be provided by Developer.",
        key: "PHE [PLUMBING SYSTEM-  Complete water supply, soil,waste & vent piping risers, sumps, underground piping upto the STP will be provided by Developer.]",
      },
      {
        label:
          "PLUMBING SYSTEM-  Piping inside the toilet for water supply, soil,waste & vent inside the toilets and Sanitarywares & fixtures",
        key: "PHE [PLUMBING SYSTEM-  Piping inside the toilet for water supply, soil,waste & vent inside the toilets and Sanitarywares & fixtures]",
      },
      {
        label:
          "PLUMBING SYSTEM-  All Water Storage Tanks - Domestic Water / Fire Protection Water/ Treated Water/ Flush Water/ Irrigation Water tank/ Make up Water Tank for Airconditioning / OH Tanks for Hydrant System/Rain Water Storage Sumps- will be provided by the Developer.",
        key: "PHE [PLUMBING SYSTEM-  All Water Storage Tanks - Domestic Water / Fire Protection Water/ Treated Water/ Flush Water/ Irrigation Water tank/ Make up Water Tank for Airconditioning / OH Tanks for Hydrant System/Rain Water Storage Sumps- will be provided by the Developer.]",
      },
      {
        label:
          "PLUMBING SYSTEM-  Water supply at each AHU Room for filter cleaning, Drainage Connections in each AHU room,etc., to be arranged by Developer",
        key: "PHE [PLUMBING SYSTEM-  Water supply at each AHU Room for filter cleaning, Drainage Connections in each AHU room,etc., to be arranged by Developer]",
      },
      {
        label:
          "PLUMBING SYSTEM-  Make up water tank for the cooling towers, Treated Water circulation piping connection from STP to the Make up water tank, domestice water supply piping till MUW Tank- To be provided by Builder",
        key: "PHE [PLUMBING SYSTEM-  Make up water tank for the cooling towers, Treated Water circulation piping connection from STP to the Make up water tank, domestice water supply piping till MUW Tank- To be provided by Builder]",
      },
      {
        label:
          "PLUMBING SYSTEM-  Rain Water storage Tanks, recharge pits, piping and fittings upto the discharge point shall be provided by the Developer.",
        key: "PHE [PLUMBING SYSTEM-  Rain Water storage Tanks, recharge pits, piping and fittings upto the discharge point shall be provided by the Developer.]",
      },
      {
        label:
          "STP-  MBR type with ultra filtration membranes ( GE Make) and softening plant / RO Plant for Cooling Tower application",
        key: "PHE [STP-  MBR type with ultra filtration membranes ( GE Make) and softening plant / RO Plant for Cooling Tower application]",
      },
      {
        label:
          "PLUMBING SYSTEM-  Treated water supply from the STP to Flushing,Irrigation and Make up water tanks",
        key: "PHE [PLUMBING SYSTEM-  Treated water supply from the STP to Flushing,Irrigation and Make up water tanks]",
      },
      {
        label:
          "WATER TREATMENT PLANT-  Complete Plant with Tanks & metering arrangement",
        key: "PHE [WATER TREATMENT PLANT-  Complete Plant with Tanks & metering arrangement]",
      },
    ],
    "IBMS SYSTEMS": [
      {
        label: "FIRE ALARM SYSTEM/ CCTV/ PA – for Common areas",
        key: "IBMS SYSTEMS [FIRE ALARM SYSTEM/ CCTV/ PA – for Common areas]",
      },
      {
        label:
          "Security Systems in occupied areas - Flap Barriers, Baggage Scanners",
        key: "IBMS SYSTEMS [Security Systems in occupied areas - Flap Barriers, Baggage Scanners]",
      },
      {
        label:
          "Perimeter Security Systems - Boom Barriers, CCTV, UVSS, Bollards, etc.,",
        key: "IBMS SYSTEMS [Perimeter Security Systems - Boom Barriers, CCTV, UVSS, Bollards, etc.,]",
      },
    ],
    "O&M CHARGES": [
      {
        label:
          "O&M for Systems supplied by the Developer inside the campus- Chillers, Elevators,DGs,STP,WTP,FPS,PHE,Basement Ventilation,Stairwell pressurisation, etc.,",
        key: "O&M CHARGES [O&M for Systems supplied by the Developer inside the campus- Chillers, Elevators,DGs,STP,WTP,FPS,PHE,Basement Ventilation,Stairwell pressurisation, etc.,]",
      },
      {
        label: "Water Supply during operation",
        key: "O&M CHARGES [Water Supply during operation]",
      },
    ],
    "OTHER SERVICES": [
      {
        label:
          "Provisions for Service Provider Connections- conduits with Primary and Secondary Paths identified",
        key: "OTHER SERVICES [Provisions for Service Provider Connections- conduits with Primary and Secondary Paths identified]",
      },
      {
        label:
          "Gas Bank/ Piped Gas Connection & Distribution upto Kitchen with required statutory approval.",
        key: "OTHER SERVICES [Gas Bank/ Piped Gas Connection & Distribution upto Kitchen with required statutory approval.]",
      },
      {
        label: "Bio Digestor for kitchen waste handling",
        key: "OTHER SERVICES [Bio Digestor for kitchen waste handling]",
      },
      {
        label: "LEED Rating - Minimum Gold for C&S",
        key: "OTHER SERVICES [LEED Rating - Minimum Gold for C&S]",
      },
      {
        label: "Sewage Bypass Connection to Municipality line",
        key: "OTHER SERVICES [Sewage Bypass Connection to Municipality line]",
      },
    ],
    "FLOORING, WALL ELEVATIONS & PLUMBING": [
      {
        label: "Water Inlet Line on Wall",
        key: "FLOORING, WALL ELEVATIONS & PLUMBING [Water Inlet Line on Wall]",
      },
      {
        label: "Drain Line Location",
        key: "FLOORING, WALL ELEVATIONS & PLUMBING [Drain Line Location]",
      },
      {
        label: "IPS finishing & PCC Required",
        key: "FLOORING, WALL ELEVATIONS & PLUMBING [IPS finishing & PCC Required]",
      },
      {
        label: "Existing waterproofing / dampness / leakage / clogging",
        key: "FLOORING, WALL ELEVATIONS & PLUMBING [Existing waterproofing / dampness / leakage / clogging]",
      },
      {
        label: "Identification of Network shaft",
        key: "FLOORING, WALL ELEVATIONS & PLUMBING [Identification of Network shaft]",
      },
      {
        label: "Identification of Plumbing & Drain shaft",
        key: "FLOORING, WALL ELEVATIONS & PLUMBING [Identification of Plumbing & Drain shaft]",
      },
      {
        label: "Metal Fire Rated Doors to be done or not",
        key: "FLOORING, WALL ELEVATIONS & PLUMBING [Metal Fire Rated Doors to be done or not]",
      },
    ],
    "Fire Alarm": [],
    "Site Images": [],
    "Site Video": [],
  };

  // Static mapping for remarks
  const remarksMapping = {
    SURROUNDINGS: "Surroundings -  Remarks",
    "NECESSARY RULES & REGULATIONS":
      "Necessary Rules and Regulations - Remarks",
  };

  // Static mapping for images
  const imageMapping = {
    "ELECTRICAL & HVAC": "ELECTRICAL & HVAC Photos",
    "ELECTRICAL WORKS": "ELECTRICAL WORKS Photos",
    Civil: "Civil Photos",
    HVAC: "HVAC Photos",
    "FIRE PROTECTION SYSTEM": "FIRE PROTECTION SYSTEM Photos",
    PHE: "PHE Photos",
    "Fire Alarm": "Fire Alarm Photos",
    "Site Images": "Site Images",
    "Site Video": "Site Video",
    "Basic Details": "floorMap",
  };

  // Initialize the output structure
  const result = {
    images: [],
    formData: [],
    companyName: data1?.["companyName"] || data1?.data?.["Project Name"],
    username: data1?.username || data1?.data?.["Name"],
    createdAt: data1?.createdAt,
    _id: data1?._id,
  };

  // Helper function to extract images from a string or array
  function extractImages(value) {
    if (Array.isArray(value)) {
      return value.filter(
        (url) => typeof url === "string" && url.includes("drive.google.com"),
      );
    }
    if (typeof value === "string" && value.includes("drive.google.com")) {
      return value
        .split(",")
        .map((url) => url.trim())
        .filter((url) => url);
    }
    return [];
  }

  // Process each heading in the fieldMapping
  Object.entries(fieldMapping).forEach(([heading, fields]) => {
    const group = { heading, tableData: [], remarks: "", images: [] };

    // Add tableData
    fields.forEach((field) => {
      const value = data1.data[field.key];
      if (value !== undefined && !extractImages(value).length) {
        group.tableData.push({ label: field.label, value });
      }
    });

    // Add remarks if applicable
    if (remarksMapping[heading]) {
      group.remarks = data1.data[remarksMapping[heading]] || "";
    }

    // Add images if applicable
    if (imageMapping[heading]) {
      const imageKeys = Array.isArray(imageMapping[heading])
        ? imageMapping[heading]
        : [imageMapping[heading]];
      imageKeys.forEach((key) => {
        let images = [];
        if (key === "floorMap") {
          images = extractImages(data1[key]);
        } else {
          images = extractImages(data1.data[key]);
        }
        group.images.push(...images);
        result.images.push(...images);
      });
    }

    // Only add group to formData if it has content
    if (
      group.tableData.length > 0 ||
      group.images.length > 0 ||
      group.remarks
    ) {
      result.formData.push(group);
    }
  });

  // Ensure unique images in top-level images array
  result.images = [...new Set(result.images)];

  return result;
};

export function googleSheetsSerialToFormattedDate(serial) {
  // 1. Convert the serial to a JS Date
  const epoch = new Date(Date.UTC(1899, 11, 30)); // 1899-12-30
  const msPerDay = 24 * 60 * 60 * 1000;
  const date = new Date(epoch.getTime() + serial * msPerDay);

  return date;
}

// export function getGoogleImageUrl(url) {
//     // Check if URL is a Google Drive link
//     if (url.includes("drive.google.com")) {
//         const match = url.match(/(?:id=|\/d\/)([a-zA-Z0-9_-]+)/);
//         if (match && match[1]) {
//           // console.log("GDRIVE", url, `https://drive.google.com/uc?export=view&id=${match[1]}`)
//             // return `https://drive.google.com/uc?export=view&id=${match[1]}`;
//             return getBase64ImageFromUrl(`https://drive.usercontent.google.com/download?id=${match[1]}&export=view&authuser=0`)
//             return `https://drive.usercontent.google.com/download?id=${match[1]}&export=view&authuser=0`;

//             //  return `https://drive.google.com/file/d/${match[1]}/preview`

//         }
//     }
//     // If not a Google Drive URL, return the original
//     return url;
// }

export function getGoogleImageUrl(url) {
  let imageUrl = url;

  // Check if URL is a Google Drive link and convert it
  if (url.includes("drive.google.com")) {
    const match = url.match(/(?:id=|\/d\/)([a-zA-Z0-9_-]+)/);
    if (match && match[1]) {
      //  imageUrl= `https://drive.google.com/thumbnail?id=${match[1]}&sz=w1000`
      // <img src="https://drive.google.com/thumbnail?id=xxxxxxxx&sz=w1000"></img>
      imageUrl = `https://drive.usercontent.google.com/download?id=${match[1]}&export=view&authuser=0`;
      // imageUrl = `http://localhost:8080/proxy?url=https://drive.google.com/thumbnail?id=${match[1]}&sz=w1000`;
    }
    // return imageUrl
    return `https://design-api.airbrickinfra.com/api/proxy/image?url=${imageUrl}`;
  }
  return url;
}

export function getUpdatedImageUrlWithSize(url, sizeArr) {
  let sizeMap = {
    1: "small",
    2: "medium",
    3: "large",
  };
  let updatedSizeArr =
    sizeArr && Array.isArray(sizeArr) ? sizeArr.map((v) => sizeMap[v]) : null;
  let size = getMinioSize(updatedSizeArr);
  size = url.includes("?") ? size.replace("?", "&") : size;
  return url + size;
}

// export function getCloudfrontUrl(url) {
//   const baseUrl = "https://d2uawae0prb92j.cloudfront.net";

//   if (!url?.includes("https://design-api.airbrickinfra.com/api/minio"))
//     return url;

//   // Remove prefix
//   let location = url.replace(
//     "https://design-api.airbrickinfra.com/api/minio",
//     "",
//   );

//   // Extract and remove query
//   const sizeMatch = location.match(/[\?&]size=([^&]+)/);
//   const size = sizeMatch ? sizeMatch[1] : null;
//   location = location.split("?")[0]; // remove query params

//   // Split path and filename
//   const lastSlashIndex = location.lastIndexOf("/");
//   const dirPath = location.slice(0, lastSlashIndex + 1); // e.g. /project-showcase/presentation/
//   const filename = location.slice(lastSlashIndex + 1); // e.g. 1762152803598-140161.jpg.webp

//   // Separate name from all extensions
//   // Match: (baseName)(.<ext1>.<ext2>... ) — one or more extensions
//   const extMatch = filename.match(/^([^.]+)((?:\.[a-zA-Z0-9]+)+)$/);

//   if (!extMatch) return baseUrl + location; // no extension case

//   const baseName = extMatch[1]; // e.g. 1762152803598-140161
//   const extensions = extMatch[2]; // e.g. .jpg.webp or .jpg

//   // Inject size after baseName, before all extensions
//   const finalLocation = size
//     ? `${dirPath}${baseName.trim()}_${size.trim()}${extensions.trim()}`
//     : `${dirPath}${baseName.trim()}${extensions.trim()}`;

//   return baseUrl + finalLocation;
// }
export function getCloudfrontUrl(url) {
  const baseUrl = "https://d2uawae0prb92j.cloudfront.net";

  if (!url?.includes("https://design-api.airbrickinfra.com/api/minio"))
    return url;

  // Remove prefix
  let location = url.replace(
    "https://design-api.airbrickinfra.com/api/minio",
    "",
  ); // e.g. /project-showcase/presentation/1762152803598-140161.jpg.webp?size=large

  // Extract and remove query
  const sizeMatch = location.match(/[\?&]size=([^&]+)/);
  const size = sizeMatch ? sizeMatch[1] : null;
  location = location.split("?")[0]; // remove query params

  // Find the last dot for extension (works for single or double extensions)
  const lastDotIndex = location.lastIndexOf(".");
  if (lastDotIndex === -1) return baseUrl + location; // no extension case

  const main = location.slice(0, lastDotIndex); // filename without last ext
  const ext = location.slice(lastDotIndex + 1); // extension part(s)

  // Inject size before the last dot
  const finalLocation = size
    ? `${main?.trim()}_${size?.trim()}.${ext?.trim()}`
    : `${main?.trim()}.${ext?.trim()}`;

  return baseUrl + finalLocation;
}
//https://design-api.airbrickinfra.com/api/minio/project-showcase/presentation/1762152803598-140161.jpg.webp?size=medium
export const TYPES_LIST = [
  "Paints",
  "Bathroom Fittings",
  "Lighting",
  "Flooring",
  "Furniture",
  "Tiles & Ceramics",
  "Stone & Marble",
  "Rugs & Carpets",
  // "Modular",
  "Laminates",
];

export const BRANDS_LIST = [
  // Paints
  {
    _id: "Asian Paints",
    logo: logos.asianPaints,
    type: "Paints",
    bannerIdx: 0,
  },

  // Bathroom Fittings
  {
    _id: "Jaquar",
    logo: logos.jaquar,
    type: "Bathroom Fittings",
    bannerIdx: 1,
  },
  {
    _id: "Kohler",
    logo: logos.kohler,
    type: "Bathroom Fittings",
    bannerIdx: 1,
  },
  {
    _id: "Grohe",
    logo: logos.grohe,
    type: "Bathroom Fittings",
    bannerIdx: 1,
  },
  {
    _id: "Toto",
    logo: logos.toto,
    type: "Bathroom Fittings",
    bannerIdx: 1,
  },

  // Lighting
  {
    _id: "Havells Lighting",
    logo: logos.havells,
    type: "Lighting",
    bannerIdx: 2,
  },
  {
    _id: "Orient Electric",
    logo: logos.orient,
    type: "Lighting",
    bannerIdx: 2,
  },
  {
    _id: "Wipro Lighting",
    logo: logos.wipro,
    type: "Lighting",
    bannerIdx: 2,
  },
  {
    _id: "Ankur Lighting",
    logo: logos.ankur,
    type: "Lighting",
    bannerIdx: 2,
  },
  {
    _id: "Philips Lighting",
    logo: logos.philips,
    type: "Lighting",
    bannerIdx: 2,
  },

  // Furniture
  {
    _id: "Featherlite",
    logo: logos.featherlite,
    bg: "bg-[#000]",
    type: "Furniture",
    bannerIdx: 4,
  },
  {
    _id: "Nilkamal",
    logo: logos.nilkamal,
    type: "Furniture",
    bannerIdx: 4,
  },
  {
    _id: "Durian",
    logo: logos.durian,
    type: "Furniture",
    bannerIdx: 4,
  },
  {
    _id: "Steelcase",
    logo: logos.steelcase,
    type: "Furniture",
    bannerIdx: 4,
  },
  {
    _id: "Herman Miller",
    logo: logos.hermanMiller,
    type: "Furniture",
    bannerIdx: 4,
  },
  {
    _id: "Haworth India",
    logo: logos.haworth,
    type: "Furniture",
    bannerIdx: 4,
  },
  {
    _id: "Ergo Space",
    logo: logos.ergospace,
    type: "Furniture",
    bannerIdx: 4,
  },
  {
    _id: "Viak",
    logo: logos.viak,
    type: "Furniture",
    bannerIdx: 4,
  },
  {
    _id: "Monarch",
    logo: logos.monarch,
    type: "Furniture",
    bannerIdx: 4,
  },
  {
    _id: "Ask Modular",
    logo: logos.askModular,
    type: "Furniture",
    bannerIdx: 4,
  },

  // Tiles & Ceramics
  {
    _id: "Kajaria Ceramics Ltd.",
    logo: logos.kajaria,
    bg: "bg-[#000]",
    type: "Tiles & Ceramics",
    bannerIdx: 5,
  },
  {
    _id: "Somany Ceramics Ltd.",
    logo: logos.somany,
    type: "Tiles & Ceramics",
    bannerIdx: 5,
  },
  {
    _id: "Nitco Ltd.",
    logo: logos.nitco,
    type: "Tiles & Ceramics",
    bannerIdx: 5,
  },
  {
    _id: "H & R Johnson (Johnson Tiles)",
    logo: logos.johnson,
    type: "Tiles & Ceramics",
    bannerIdx: 5,
  },
  {
    _id: "Simpolo Ceramics",
    logo: logos.simpolo,
    bg: "bg-[#000]",
    type: "Tiles & Ceramics",
    bannerIdx: 5,
  },
  {
    _id: "Orient Bell Limited",
    logo: logos.orientbell,
    bg: "bg-[#333]",
    type: "Tiles & Ceramics",
    bannerIdx: 5,
  },
  {
    _id: "Rak ceramics",
    logo: logos.rak,
    type: "Tiles & Ceramics",
    bannerIdx: 5,
  },

  // Flooring
  {
    _id: "Responsive Industries",
    logo: logos.responsiveIndustries,
    type: "Flooring",
    bannerIdx: 3,
  },
  {
    _id: "Welspun Flooring",
    logo: logos.welspun,
    type: "Flooring",
    bg: "bg-[#000]",
    bannerIdx: 3,
  },
  {
    _id: "Pergo (LVP)",
    logo: logos.pergo,
    type: "Flooring",
    bannerIdx: 3,
  },
  {
    _id: "Armstrong Flooring",
    logo: logos.armstrong,
    type: "Flooring",
    bannerIdx: 3,
  },

  // Stone & Marble
  {
    _id: "Kalinga Stone",
    logo: logos.kalinga,
    bg: "bg-[#000]",
    type: "Stone & Marble",
    bannerIdx: 6,
  },

  // Rugs & Carpets
  {
    _id: "Jaipur Rugs",
    logo: logos.jrc,
    type: "Rugs & Carpets",
    bannerIdx: 7,
  },

  // Modular

  // Laminates
  {
    _id: "Merino",
    logo: logos.merino,
    type: "Laminates",
    bannerIdx: 8,
  },
  {
    _id: "Greenlam",
    logo: logos.greenlam,
    type: "Laminates",
    bannerIdx: 8,
  },
];

export const MaterialBannerData = [
  {
    type: "Paints",
    bg: Paints,
    info: ["Professional Finishes For Productive,", "Stylish Office Spaces"],
    icons: materialIcons.mIconimg539,
  },
  {
    type: "Bathroom Fittings",
    bg: Bathroom,
    info: ["Premium bathroom fittings for modern,", " elegant spaces"],
    icons: materialIcons.mIconimg540,
  },
  {
    type: "Lighting",
    bg: Lightning,
    info: ["Elevate Your Space with Bold,", "Focused Lighting."],
    icons: materialIcons.mIconimg508,
  },
  {
    type: "Flooring",
    bg: Flooring,
    info: ["Scratch-proof surfaces that stay", " beautiful under pressure"],
    icons: materialIcons.mIconimg544,
  },
  {
    type: "Furniture",
    bg: Furniture,
    info: ["Modern, comfortable furnitures that", "elevate everyday living"],
    icons: materialIcons.mIconimg537,
  },
  {
    type: "Tiles & Ceramics",
    bg: Tiles,
    info: ["Handcrafted ceramics bring warmth,", "character, charm indoors"],
    icons: materialIcons.mIconimg541,
  },
  {
    type: "Stone & Marble",
    bg: Stones,
    info: ["Premium stone and marbles for", "timeless elegance"],
    icons: materialIcons.mIconimg543,
  },
  {
    type: "Rugs & Carpets",
    bg: Rugs,
    info: ["Runner rugs, area carpets, perfect", "hallway accents"],
    icons: materialIcons.mIconimg538,
  },
  // {
  //   type: "Modular",
  //   bg: Modular,
  //   info: ["Space saving modular designs built to", "last"],
  //   icons: materialIcons.mIconimg546,
  // },
  {
    type: "Laminates",
    bg: Laminates,
    info: ["Premium laminates for stylish, durable", "interior finishes"],
    icons: materialIcons.mIconimg502,
  },
];
// console.log({ BRANDS_LIST });

export function getMaterialPills(materialData) {
  //  ...JSON.parse(v?.otherDetails || "{}"),
  // color:JSON.parse(v?.['popular_shades/textures']),
  // material: v?.material,
  //   size: v?.size,
  //  category: v?.Cateogry,
  // floorType : v?.floorType,
  // collection: v?.collection,
  // material : v?.material,
  // subCategory: v?.subcategory_name,
  // subSubCategory: v?.type2,
  // variants : v?.variation,
  // images: JSON.parse(v?.images),
  //    productUrl: v?.['Product link'],
  //   mrpPrice: v?.price,
  // salePrice: v?.SalePrice,
  // features: JSON.parse(v?.features),
  // features: JSON.parse(v?.features),
  // brand: v?.brand,
  // thickness : v?.thickness,
  // description :v?.description,
  const allKeys = [
    "otherDetails",
    "color",
    "material",
    "size",
    "category",
    "floorType",
    "collection",
    "material",
    "subCategory",
    "subSubCategory",
    "variants",
    "images",
    "productUrl",
    "mrpPrice",
    "salePrice",
    "features",
    "brand",
    "thickness",
    "description",
  ];
  const allowedPillKeys = [
    // "otherDetails",
    "color",
    "material",
    "size",
    "category",
    "floorType",
    "collection",
    "material",
    "subCategory",
    "subSubCategory",
    // "variants",
    // "images",
    // "productUrl",
    "mrpPrice",
    "salePrice",
    "features",
    "brand",
    "thickness",
    // "description"
  ];

  let ans = {};
  Object.keys(materialData).forEach((key) => {
    if (allowedPillKeys.includes(key)) {
      let value = materialData[key];
      if (Array.isArray(value)) {
        ans[key] = value.slice(0, 3)?.join(", ");
      } else {
        ans[key] = value;
      }
    }
  });

  return ans;
}

export function shuffleArray(array) {
  const shuffled = [...array]; // make a copy to avoid mutating original
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1)); // pick random index
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]; // swap
  }
  return shuffled?.flat();
}

const MINIO_API_PREFIX = "https://design-api.airbrickinfra.com/api/minio";

// Ordered list of URLs to try for an image. Sized variants (e.g. 123_small.jpg)
// only exist on CloudFront once the API has generated them, so fall back to the
// CloudFront original before hitting the (slower) resizing API.
export function getImageFallbackChain(url) {
  if (!url?.includes(MINIO_API_PREFIX)) return [url];
  const chain = [
    getCloudfrontUrl(url),
    getCloudfrontUrl(url.split("?")[0]),
    url,
  ];
  return [...new Set(chain)];
}

const warmedVariants = new Set();

// Ask the API to queue a missing sized variant so the CloudFront copy exists
// next time. HEAD skips the body; fire-and-forget, once per URL per session.
export function warmMinioVariant(url) {
  if (!url?.includes(MINIO_API_PREFIX) || !/[?&]size=/.test(url)) return;
  if (warmedVariants.has(url)) return;
  warmedVariants.add(url);
  fetch(url, { method: "HEAD", mode: "no-cors" }).catch(() => {});
}
